// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__tikZ0","rotation":"style_rotation__q+OWd","small":"style_small__InRst","normal":"style_normal__Y6Wsy","large":"style_large__fFskQ"};